<mdb-card cascade="true" narrower="true" class="unique-color text-white">
   <h4 class="m-2"><i class="fa fa-info-circle mr-1"></i> {{ heading }}</h4>
   <div class="m-2" *ngFor="let item of infoLines"><i class="fa fa-angle-right mr-1"></i> {{ item }}</div>
</mdb-card>
